<adapt-feature-guidance [configItem]="configItem"></adapt-feature-guidance>
<adapt-feature-configuration [configItem]="configItem"></adapt-feature-configuration>
